<template>
  <div :class="{'fixed-wrapper': true, 'show': isShow}" @click.self="$emit('close')">
    <div class="k-popup">
      <div class="k-popup__body">
        <slot name="body"></slot>
      </div>
      <div class="k-popup__bottom">
        <slot name="bottom"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    isShow: Boolean
  }
}
</script>
<style lang="scss" scoped>
.fixed-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.15);
  z-index: 10;

  display: flex;
  justify-content: center;
  align-items: center;
}

.k-popup {
  max-width: 690px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #EBEBEB;
  box-sizing: border-box;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  padding: 40px;
  max-height: 80vh;
  overflow-y: auto;

  &__bottom {
    padding: 20px 0 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
}
</style>
